import { DirectusSDK } from "./types/DirectusSDK";
export let directusSDK = new DirectusSDK();
export function getImageUrl(imageId, size) {
    let sizeQuery = size ? `?width=${size.w}&height=${size.h}` : '';
    return `${DIRECTUS_API_URL}assets/${imageId}?fit=contain&access_token=${directusSDK.getAuthToken()}&${sizeQuery}`;
}
export function getPdfFileUrl(fileId) {
    return `${DIRECTUS_API_URL}assets/${fileId}?access_token=${directusSDK.getAuthToken()}`;
}
